export default (value) => {
  const formatter = new Intl.NumberFormat("da-DK", {
    style: "currency",
    currency: "DKK",
  });
  return formatter.format(value || 0);
};
